import { render, staticRenderFns } from "./StudyPlansTable.vue?vue&type=template&id=08619a58"
import script from "./StudyPlansTable.vue?vue&type=script&lang=js"
export * from "./StudyPlansTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports